import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription } from "rxjs";
import { AppState } from "src/app/store/app.reducer";
import { selectExportedFinalUsersList, selectExportingFinalUsersList } from "src/app/store/user-file/user-file.selector";
import * as UserFileActions from 'src/app/store//user-file/user-file.actions';
import { StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { FinalUsersList } from "src/app/model/final-users-list";
import { COMMAND_NAME_VALID_REGEXP } from "src/app/conf/commands";
import { User } from "src/app/model/user";
import { selectIsImpersMode, selectUser } from "src/app/store/user/user.selector";

@Component({
	templateUrl: './export-final-users-dialog.component.html',
})

export class ExportFinalUsersDialogComponent implements OnInit, OnDestroy {
	finalUserListForm: FormGroup;

	exporting = false;
	exporting$: Observable<boolean | undefined>;
	exportingSub: Subscription;

	exported = false;
	exported$: Observable<boolean | undefined>;
	exportedSub: Subscription;

	currentUser: User;
	currentUser$: Observable<User | undefined>;
	currentUserSub: Subscription | undefined;

	isImpersMode: boolean;
	isImpersMode$: Observable<boolean | undefined>;
	isImpersModeSub: Subscription | undefined;

	finalUsersList: FinalUsersList = new FinalUsersList();

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig,

	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();
		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.exportingSub?.unsubscribe();
		this.exportedSub?.unsubscribe();
		this.currentUserSub?.unsubscribe();
		this.isImpersModeSub?.unsubscribe();
	}

	initSelectors(): void {
		this.exporting$ = this.store.select(selectExportingFinalUsersList);
		this.exported$ = this.store.select(selectExportedFinalUsersList);
		this.currentUser$ = this.store.select(selectUser);
		this.isImpersMode$ = this.store.select(selectIsImpersMode);
	}

	buildForm(): void {
		this.finalUserListForm = new FormGroup({
			'name': new FormControl(this.finalUsersList.Name, [Validators.required, Validators.pattern(COMMAND_NAME_VALID_REGEXP)]),
		});
	}

	subscribeAll(): void {
		this.currentUserSub = this.currentUser$?.subscribe(currentUser => {
			this.currentUser = currentUser;
		});
		this.isImpersModeSub = this.isImpersMode$?.subscribe(
			(isImpersMode) => {
				this.isImpersMode = isImpersMode;
			}
		);
		this.exportingSub = this.exporting$?.subscribe(
			(exporting) => {
				this.exporting = exporting;
			}
		);
		this.exportedSub = this.exported$?.subscribe(
			(exported) => {
				if (exported) {
					this.store.dispatch(UserFileActions.resetFinalUsersList());
					this.closeDialog();
				}
			}
		);
	}

	get f(): any {
		return this.finalUserListForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.finalUserListForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.finalUserListForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		if (this.isImpersMode) {
			this.store.dispatch(UserFileActions.exportFinalUsersList({
				name: this.finalUserListForm.value.name, userId: this.currentUser.Id
			}));
		} else {
			this.store.dispatch(UserFileActions.exportFinalUsersList({
				name: this.finalUserListForm.value.name, userId: null,
			}));
		}
	}

	closeDialog(): void {
		this.ref.close();
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: ExportFinalUsersDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type, classType, this.screenWidth);
	}

	showErrorRequiredMessage(type: ExportFinalUsersDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}
}